import uniqueId from 'lodash/uniqueId';
import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Search = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => {
  const clipId = uniqueId('clip_');

  return (
    <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M1.85871 8.7916C2.40713 10.082 3.44571 11.1018 4.74598 11.6264C6.04624 12.1511 7.50168 12.1378 8.79211 11.5894C10.0825 11.0409 11.1023 10.0024 11.6269 8.70209C12.1516 7.40183 12.1383 5.94639 11.5899 4.65596C11.0414 3.36553 10.0029 2.34581 8.7026 1.82113C7.40234 1.29645 5.9469 1.30978 4.65647 1.8582C3.36604 2.40662 2.34632 3.4452 1.82164 4.74547C1.29696 6.04573 1.31029 7.50117 1.85871 8.7916V8.7916Z"
          stroke={getColor(color, isColorInherited)}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4623 10.4617L14.5625 14.5626"
          stroke={getColor(color, isColorInherited)}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect height={height} width={width} fill="none" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
